import { useTranslation } from "react-i18next";

import { ChillIcon } from "@/CAREUI/icons/CustomIcons";

import { SymptomsList } from "@/components/Patient/symptoms/list";

export const SymptomsHistory = ({ patientId }: { patientId: string }) => {
  const { t } = useTranslation();
  return (
    <div className="max-w-5xl mx-auto">
      <div className="flex items-center gap-2 mb-5">
        <ChillIcon className="size-8 text-pink-700 bg-pink-100 border border-pink-400 rounded-md p-1" />
        <h4 className="text-xl">{t("past_symptoms")}</h4>
      </div>
      <SymptomsList patientId={patientId} showTimeline={true} />
    </div>
  );
};
